import React, { useState, useEffect, useRef } from "react";
import { get, post } from "../../utils/HttpRequest";
import config from "../../config/config.json";
import Header from "../Header/Header";
import { Row, Col, Container, Card } from "react-bootstrap";
import MediaFrame from "./MediaFrame";
import Sidebar from "./Sidebar";
// import LessonHeader from "./LessonHeader";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import AssessmentProgressBar from "./AssessmentProgressBar";

const LessonviewLarge = () => {
  
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const lessonid = params.get("lessonid");

  const navigate = useNavigate();
  var topicid = params.get("topicid");
  var [selectedLanguage, setSelectedLanguage] = useState(
    params.get("language")
  );
  var [lessonData, setlessonData] = useState(null);

  var [topicToLoad, settopicToLoad] = useState(null);
  // var [lessonurl, setlessonurl] = useState(null);
  var [isAssessment, setIsAssessment] = useState(false);
  var [isSurvey, setIsSurvey] = useState(false);
  var [notTopicsDialogVisible, setNoTopicsDialogVisible] = useState(false);
  var [otherRoleReviewFlag, setOtherRoleReviewFlag] = useState(false);
  var [retakeFlag, setRetakeFlag] = useState(false);
  var [ackFlag, setAckFlag] = useState(false);
  var [retakeDialogVisible, setRetakeDialogVisible] = useState(false);
  var [sideBarToggle, setSideBarToggle] = useState(true);
  // var [isRetakeClicked, setIsRetakeClicked] = useState(false);
  var [isLargeLessonView, setIsLargeLessonView] = useState(true);
  var [searchDashboardData, setSearchDashboardData] = useState([]);
  var [isPageLoading, setIsPageLoading] = useState(true);

  var [isRetakeClicked, setIsRetakeClicked] = useState(false);

  var [hideNavbar] = useState(true);

  var parentids = params.get("parentids");
  var parentNames = params.get("parentNames");
  var [parentLessonNames, setparentLessonNames] = useState([]);
  var [parentLessonIds, setparentLessonIds] = useState([]);

  var [maxAttemptsAssessment, setMaxAttemptsAssessment] = useState(5);
  var [maxAttemptsAssessmentMessage, setMaxAttemptsAssessmentMessage] = useState("");
  var [maxAttemptLimitReached, setMaxAttemptLimitReached] = useState(false);

  // Track if lesson was already loaded (to detect topic-only switches)
  const loadedLessonRef = useRef(null);

  // Latest completion record — sorted by addedEpoch desc — feeds score/result into the bar
  var [latestCompletionRecord, setLatestCompletionRecord] = useState(null);
  var [allCompletionRecords, setAllCompletionRecords] = useState([]);
  var [isTrialDUser, setIsTrialDUser] = useState(false);

  const loadLessondata = (lessonurl, _topicIdParam, isTopicSwitch = false) => {
    // Start Pace loader manually - it will stay until API completes
    
    // Only show full-page loader on initial load or lesson change, not topic switch
    if (!isTopicSwitch) {
      setIsPageLoading(true);
      setlessonData(null);
      settopicToLoad(null);
      setIsAssessment(false);
      setIsSurvey(false);
      setAckFlag(false);
      setRetakeFlag(false);
      setMaxAttemptLimitReached(false);
    }
    
    localStorage.removeItem("lessonid");
    localStorage.removeItem("topicid");

    get(config.api.url + "getSearchTerms").then((result) => {
      setSearchDashboardData(result.data.dashboard);
    });

    post(lessonurl).then(async (response) => {
      const lesson = response.data.getLessonandTopicsFuncResponse;
      response.data.getTopicsViewedByUserFuncResponse.topics.map(o=>{
        console.log('topic: '+o.topicid+' '+o.topicviewed);
      });
      let topicToPass = null;
      // var topicViewedCounts = {};

      // Pick the most recent completion record (largest addedEpoch)
      const completionRecords = response.data.getCompletionRecordsForUserResponse ?? [];
      if (completionRecords.length > 0) {
        const sorted = [...completionRecords].sort((a, b) => b.addedEpoch - a.addedEpoch);
        setLatestCompletionRecord(sorted[0]);
        setAllCompletionRecords(sorted);
      } else {
        setLatestCompletionRecord(null);
        setAllCompletionRecords([]);
      }

      if (
        localStorage.getItem("userRole") != null &&
        `${localStorage.getItem("userRole")}`.toLowerCase() == "cro"
      ) {
        let url = config.api.url + "getTrialConfig/croLessonReview";
        await get(url)
          .then((result) => {
            let sponsorLessonReview = result.data;
            if (sponsorLessonReview.value == true) {
              // hide review tile from topmenubar
              setOtherRoleReviewFlag(true);
            }
          })
          .catch((err) => {
            console.log("Error getting croLessonReview data.", err);
          });
      } else if (
        localStorage.getItem("userRole") != null &&
        `${localStorage.getItem("userRole")}`.toLowerCase() == "sponsor"
      ) {
        let url = config.api.url + "getTrialConfig/sponsorLessonReview";
        await get(url)
          .then((result) => {
            let sponsorLessonReview = result.data;
            if (sponsorLessonReview.value == true) {
              // hide review tile from topmenubar
              setOtherRoleReviewFlag(true);
            }
          })
          .catch((err) => {
            console.log("Error getting sponsorLessonReview data.", err);
          });
      }

      if (
        lesson.lessondetails.status === "active" ||
        otherRoleReviewFlag ||
        (localStorage.getItem("userRole") != null &&
          `${localStorage.getItem("userRole")}`.toLowerCase() === "smiadmin")
      ) {
        if (lesson && lesson.topics && lesson.topics.length === 0) {
          setNoTopicsDialogVisible(true);
          setlessonData(lesson);
        } else {
          if (lesson.topics.length > 0) {
            let tempTopic = lesson.topics.find(
              (t) =>
                t.topic_id ===
                response.data.getTopicDetailsFuncResponse.topic_id
            );
            topicToPass = response.data.getTopicDetailsFuncResponse;
            if (tempTopic && tempTopic["topicfolder"]) {
              topicToPass["topicfolder"] = tempTopic["topicfolder"];
            }
            localStorage.setItem("topicid", topicToPass.topic_id);
            setNoTopicsDialogVisible(false);
          } else {
            setNoTopicsDialogVisible(true);
          }
          if (
            !selectedLanguage &&
            localStorage.getItem("userLanguage") &&
            topicToPass.language
          ) {
            let topicLanguage = topicToPass.language
              .split(",")
              .map((x) => x.trim());
            if (
              topicLanguage.indexOf(localStorage.getItem("userLanguage")) !=
              -1 &&
              localStorage.getItem("userLanguage") != "English"
            ) {
              setSelectedLanguage(localStorage.getItem("userLanguage"));
            } else {
              setSelectedLanguage("English");
            }
          } else {
            let topicLanguage = topicToPass?.language
              ?.split(",")
              .map((x) => x.trim());
            if (
              selectedLanguage !== "" &&
              topicLanguage &&
              topicLanguage.indexOf(selectedLanguage) != -1 &&
              selectedLanguage !== "English"
            ) {
              setSelectedLanguage(selectedLanguage);
            } else {
              setSelectedLanguage("English");
            }
          }
          localStorage.setItem("prevLanguage", selectedLanguage);
          let topicViewedCounts = {};

          let viewedLessonData =
            response.data.getTopicsViewedByUserFuncResponse;

          if (
            response.data.getTopicsViewedByUserFuncResponse &&
            viewedLessonData.topics &&
            viewedLessonData.topics.length > 0
          ) {
            
            //Jun-28-2025 : Hiren : Fix for last topic had to be clicked twice for acknowledge button to show
            // Skip for assessments: there "viewed" means "answered", so marking the newly
            // loaded question as viewed made the last question get skipped (redirect to acknowledge).
            console.log("viewedLessonData.topics1: "+JSON.stringify(viewedLessonData.topics));
            if (viewedLessonData.lessondetails?.lessontype !== "assessment") {
              viewedLessonData.topics = viewedLessonData.topics.map(o=> {
                if(o.topic_id==topicid){
                    console.log("current topicID is: "+topicid);
                  return { ...o,
                        topicviewed: true
                      };
                }
                return o;
              })
            }

            console.log("viewedLessonData.topics2: "+JSON.stringify(viewedLessonData.topics));            
            viewedLessonData.topics.forEach((value) => {
              topicViewedCounts[value.topicviewed] =
                (topicViewedCounts[value.topicviewed] || 0) + 1;
              if (selectedLanguage) {
                value.selectedLanguage = selectedLanguage;
              }
            });
          }
          console.log("topicViewedCounts: "+JSON.stringify(topicViewedCounts));
          if (!topicViewedCounts.false) {
            if (
              topicToPass &&
              viewedLessonData.lessondetails.lessontype === "assessment"
            ) {
              setIsAssessment(true);
              setMaxAttemptLimitReached(false);
              if (viewedLessonData.lessondetails.lessonComplete == "true") {
                // show retake button / UI from here
                  try {
                    const res1 = await get(config.api.url + "getTrialConfig/noOfMaxAttemptsAllowedForAssessment");
                    const res2 = await get(config.api.url + "getTrialConfig/messageForAssessmentScoreThreshold");

                    if (res1?.data?.value) setMaxAttemptsAssessment(res1.data.value);
                    if (res2?.data?.value) setMaxAttemptsAssessmentMessage(res2.data.value);

                    if (response.data && response.data.getCompletionRecordsForUserResponse.length > 0) {
                      if (response.data.getCompletionRecordsForUserResponse.length >= parseInt(res1.data.value)) {
                        var allLessonArchievedCount = 0;
                        response.data.getCompletionRecordsForUserResponse.forEach(lesson => {
                          if(lesson && lesson.logid.startsWith('archive-')) {
                            allLessonArchievedCount += 1;
                          }
                        })
                        if(allLessonArchievedCount == response.data.getCompletionRecordsForUserResponse.length) {
                          setRetakeFlag(true);
                          setMaxAttemptLimitReached(false);
                        } else {
                          setMaxAttemptLimitReached(true);
                        }
                      } else {
                        setRetakeFlag(true);
                      }
                    } else {
                      setRetakeFlag(true);
                    }
                  } catch (err) {
                     console.log("Error handling max Attempt for assessment :: ", err)
                    setRetakeFlag(true);
                  }

              } else if (
                viewedLessonData.lessondetails.lessonComplete == "false"
              ) {
                let url =
                  "/acknowledge?lessonid=" +
                  viewedLessonData.lessondetails.lessonid;
                if (selectedLanguage && selectedLanguage !== "") {
                  url = url + "&language=" + selectedLanguage;
                }

                navigate(url);
              }
            } else if (viewedLessonData.lessondetails.status == "review") {
              // hide acknowledge button in topmenu bar
              setAckFlag(false);
            } else if (
              viewedLessonData.lessondetails.lessonComplete == "false" &&
              viewedLessonData.lessondetails.acknowledgementRequired &&
              viewedLessonData.lessondetails.acknowledgementRequired != "no"
            ) {
              console.log("topic viewed");
              // show acknowledge button in topmenu bar
              setAckFlag(true);
            }
          } else {
            if (
              topicToPass &&
              lesson.lessondetails.lessontype === "assessment"
            ) {
              setIsAssessment(true);
              let obj = [];
              Object.keys(topicToPass).map((key) => {
                if (key.includes("answer") && key !== "answer") {
                  obj.push({ key: key, value: topicToPass[key] });
                }
              });
              topicToPass["answersToLoad"] = obj;
              try {
                const res1 = await get(config.api.url + "getTrialConfig/noOfMaxAttemptsAllowedForAssessment");
                const res2 = await get(config.api.url + "getTrialConfig/messageForAssessmentScoreThreshold");

                if (res1?.data?.value) setMaxAttemptsAssessment(res1.data.value);
                if (res2?.data?.value) setMaxAttemptsAssessmentMessage(res2.data.value);

                if (response.data && response.data.getCompletionRecordsForUserResponse.length > 0) {
                  if (response.data.getCompletionRecordsForUserResponse.length >= parseInt(res1.data.value)) {
                    var allLessonArchievedCount = 0;
                    response.data.getCompletionRecordsForUserResponse.forEach(lesson => {
                      if (lesson && lesson.logid.startsWith('archive-')) {
                        allLessonArchievedCount += 1;
                      }
                    })
                    if (allLessonArchievedCount == response.data.getCompletionRecordsForUserResponse.length) {
                      setRetakeFlag(false);
                      setMaxAttemptLimitReached(false);
                    } else {
                      setMaxAttemptLimitReached(true);
                    }
                  } 
                  // else {
                  //   setRetakeFlag(true);
                  // }
                }
              } catch (err) {
                console.log("Error handling max Attempt for assessment :: ", err)
              }
            }
          }
          if (
            viewedLessonData.lessondetails?.lessonlanguages &&
            viewedLessonData.lessondetails?.lessonlanguages.includes(",")
          ) {
            viewedLessonData.lessondetails["languages"] =
              viewedLessonData.lessondetails.lessonlanguages
                .split(",")
                .map((x) => x.trim());
          }
          if(viewedLessonData.lessondetails.lessontype === "survey"){
            setIsSurvey(true);
          }
          settopicToLoad(topicToPass);
          localStorage.setItem("topics", JSON.stringify(lesson.topics));
          localStorage.setItem("lessonid", lessonid);
          setlessonData(viewedLessonData);
        }
      }
      setIsPageLoading(false);
    }).catch((err) => {
      console.log("Error loading lesson data:", err);
      setIsPageLoading(false);
    });
  };

  useEffect(() => {
    if (parentNames !== null && parentids !== null) {
      setparentLessonNames(
        parentNames
          .split("|")
          .filter((n) => n)
          .slice(0, -1)
      );
      setparentLessonIds(
        parentids
          .split("|")
          .filter((n) => n)
          .slice(0, -1)
      );
    } else {
      setparentLessonNames([]);
      setparentLessonIds([]);
    }
    let lesson_url =
      config.api.url + "getLessonViewDetails?lessonid=" + lessonid;
    if (topicid !== null && topicid !== "") {
      lesson_url = lesson_url + "&topicid=" + topicid;
    }
    lesson_url = lesson_url + "&limit=5";

    // If same lesson was already loaded, this is just a topic switch
    const isTopicSwitch = loadedLessonRef.current === lessonid;
    loadLessondata(lesson_url, topicid, isTopicSwitch);
    loadedLessonRef.current = lessonid;
  }, [topicid, lessonid]);


  const onClickTopics = (event) => {

    console.log("onClickTopics: maxAttemptLimitReached: "+maxAttemptLimitReached);
    if(maxAttemptLimitReached){
      return;
    }
    let topicid = event.target.id;
    
    let searchParams = `?lessonid=${lessonid}&topicid=${topicid}`;
    if (parentids) {
      searchParams += `&parentids=${parentids}`;
    }
    if (parentNames) {
      searchParams += `&parentNames=${parentNames}`;
    }
    
    navigate({
      pathname: window.location.pathname,
      search: searchParams,
      replace: true,
    });
  };

  // Functions to handle next and previous clicks
  const clickNextBtnFunc = () => {
    let topics = JSON.parse(localStorage.getItem("topics"));
    let currentTopic = localStorage.getItem("topicid");
    let indexOfTopic = topics.findIndex((x) => x.topic_id == currentTopic);
    if (
      indexOfTopic != null &&
      indexOfTopic != null &&
      indexOfTopic + 1 >= topics.length - 1
    ) {
      if (
        lessonData?.lessondetails?.lessontype === "regularlesson" &&
        lessonData?.lessondetails?.status === "active"
      ) {
        setAckFlag(true);
      }
    }
    if (
      indexOfTopic != null &&
      indexOfTopic != null &&
      indexOfTopic < topics.length - 1
    ) {
      let topicid = topics[indexOfTopic + 1].topic_id;
      loadLessondata(
        config.api.url +
        "getLessonViewDetails?lessonid=" +
        lessonid +
        "&topicid=" +
        topicid +
        "&limit=5",
        topicid,
        true
      );
    }
    if (
      indexOfTopic != null &&
      indexOfTopic != null &&
      indexOfTopic === topics.length - 1
    ) {
      // redirect to acknowledgement page, or show ack not allowed based on review flag
      let topicid = topics[indexOfTopic].topic_id;
      loadLessondata(
        config.api.url +
        "getLessonViewDetails?lessonid=" +
        lessonid +
        "&topicid=" +
        topicid +
        "&limit=5",
        topicid,
        true
      );
      let url = `/acknowledge?lessonid=${lessonid}`;
      if (selectedLanguage && selectedLanguage !== "") {
        url = url + "&language=" + selectedLanguage;
      }
      navigate(url);
    }
  };

  const clickPrevBtnFunc = () => {
    let topics = JSON.parse(localStorage.getItem("topics"));
    let currentTopic = localStorage.getItem("topicid");
    let indexOfTopic = topics.findIndex((x) => x.topic_id == currentTopic);
    if (indexOfTopic != null && indexOfTopic != null && indexOfTopic >= 1) {
      let topicid = topics[indexOfTopic - 1].topic_id;
      loadLessondata(
        config.api.url +
        "getLessonViewDetails?lessonid=" +
        lessonid +
        "&topicid=" +
        topicid +
        "&limit=5",
        topicid,
        true
      );
    }
  };

  const handleRetakeAction = () => {
    var url = config.api.url + "retakeAssessmentForMe";
    const lessonid = lessonData.lessondetails.lessonid;
    setIsRetakeClicked(true);
    post(url, JSON.stringify({ lessonid: lessonid }))
      .then(() => {
        // let userData = result.data;
        let urlToRedirect = "";

        if (window.location.pathname.includes("lessonviewassessmentmobile")) {
          urlToRedirect = "/lessonviewassessmentmobile?lessonid=" + lessonid;
        } else {
          urlToRedirect = "/lessonview?lessonid=" + lessonid;
        }
        window.location.href = urlToRedirect;
        // navigate(urlToRedirect)
      })
      .catch((err) => {
        console.log("Error in retake assessment api call", err);
      });
  };

  const handleLanguageChange = (language) => {
    let urlToRedirect = "";
    if (window.location.pathname.includes("lessonviewassessmentmobile")) {
      urlToRedirect =
        "/lessonviewassessmentmobile?lessonid=" +
        lessonid +
        "&language=" +
        language;
    } else {
      urlToRedirect =
        "/lessonview?lessonid=" + lessonid + "&language=" + language;
    }
    setSelectedLanguage(language);
    navigate(urlToRedirect);
  };
  // Sidebar is hidden entirely in assessment mode
  const showSidebar = !isAssessment;
  if (lessonData !== null && lessonData !== undefined) {
    return (
      <div className="lessonviewPage app" style={{ overflowX: "hidden" }}>
        {/* pass `isLargeLessonView` instead of true to get the header disappear in realtime when clicking hamburger icon */}
        <Header
          isLargeLessonView={isLargeLessonView}
          searchDashboardData={searchDashboardData}
          hideNavbar={hideNavbar}
          onTrialDUserLoaded={setIsTrialDUser}
        />

        {/* <LessonHeader
          lessondetails={lessonData.lessondetails}
          retakeFlag={retakeFlag}
          ackFlag={ackFlag}
          selectedLanguage={selectedLanguage}
          retakeHandler={(e) => {
            setRetakeDialogVisible(true);
          }}
          languageChangeHandler={(language) => {
            handleLanguageChange(language);
          }}
        /> */}
        <nav
          aria-label="breadcrumb"
          id="nestedlessonBreadcrumb"
          className={`pl-4 mr-2 mb-0 pb-0  ${!isLargeLessonView ? "mt-3" : "m-0"
            }`}
        >
          <ol
            className="breadcrumb breadcrumb-no-gutter"
            style={{ alignItems: "center" }}
          >
            <li className="breadcrumb-item">
              <a
                className="breadcrumb-link"
                href="dashboard"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/dashboard`);
                }}
              >
                Home
              </a>
            </li>
            {parentLessonNames.length > 0
              ? parentLessonNames.map((parentName, j) => (
                <li className="breadcrumb-item" key={parentName}>
                  <a
                    className="breadcrumb-link"
                    href={`dashboard?lessonid=${parentLessonIds[j]
                      }&parentids=${parentLessonIds
                        .slice(0, j + 1)
                        .join("|")}&parentNames=${parentLessonNames
                          .slice(0, j + 1)
                          .join("|")}`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/dashboard?lessonid=${parentLessonIds[j]
                        }&parentids=${parentLessonIds
                          .slice(0, j + 1)
                          .join("|")}&parentNames=${parentLessonNames
                            .slice(0, j + 1)
                            .join("|")}`
                      );
                    }}
                  >
                    {parentLessonNames[j]}
                  </a>
                </li>
              ))
              : // <li className="breadcrumb-item" >
              //   <a
              //     className="breadcrumb-link"
              //     >
              //       {lessonData.lessondetails.lessonname}
              //   </a>
              // </li>
              null}

            <li>
              <h5
                style={{ border: "none" }}
                className="card-header"
                id="sideBarLessonName"
                title={lessonData.lessondetails.lessonname}
              >
                {lessonData.lessondetails.lessonname}{" "}
                {!isTrialDUser && (
                  <a
                    id="lessonviewPageShare"
                    href={`messages?newmessage=yes&lessonlink=${window.location}/lessonview?lessonid=${lessonData.lessondetails.lessonid}&lessonname=${lessonData.lessondetails.lessonname}#messagePageMessageCard`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/messages?newmessage=yes&lessonlink=${window.location}/lessonview?lessonid=${lessonData.lessondetails.lessonid}&lessonname=${lessonData.lessondetails.lessonname}#messagePageMessageCard`
                      );
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ fontSize: "1.25rem" }}
                    />
                  </a>
                )}
              </h5>
            </li>
            <li>
              <div
                className={`pl-5 pr-5 ${lessonData.lessondetails.languages &&
                  lessonData.lessondetails.languages.length > 1 &&
                  !retakeFlag
                  ? "d-inline-flex"
                  : "d-none"
                  }`}
                id="languageSelectDiv"
              >
                <label
                  className="mt-2 sidebar-center-content d-inline-flex"
                  htmlFor="languageSelect"
                >
                  {" "}
                  Available languages
                </label>
                <select
                  className="custom-select custom-select-sm d-inline-block mt-2 ml-1 mb-2 d-block col-md-5"
                  id="languageSelect"
                  value={selectedLanguage ? selectedLanguage : ""}
                  onChange={(e) => {
                    handleLanguageChange(e.target.value);
                  }}
                >
                  {lessonData.lessondetails.languages &&
                    lessonData.lessondetails.languages?.length > 1 &&
                    lessonData.lessondetails.languages.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                </select>
              </div>
            </li>

            <li>
              <button
                type="button"
                id="lessonComplete"
                onClick={() => {
                  let url =
                    "/acknowledge?lessonid=" +
                    lessonData.lessondetails.lessonid;
                  if (selectedLanguage && selectedLanguage !== "") {
                    url = url + "&language=" + selectedLanguage;
                  }
                  navigate(url);
                }}
                className={`lessonViewLessonComplete  btn btn-primary btn-xs ml-3 ${ackFlag ? "" : "d-none"
                  }`}
              >
                Acknowledge Completion
              </button>
            </li>
          </ol>
        </nav>
        <Container className="m-1 d-flex flex-column" fluid style={{ height: "100vh" }}>
          {lessonData.topics.length > 1 ? (
            <Row className="flex-grow-1 m-0">
              {/* Sidebar: hidden in assessment mode */}
              {showSidebar && (
              <Col
                lg="3"
                md="3"
                sm="3"
                xs="12"
                className={`${sideBarToggle ? "" : "d-none"}`}
              >
                <Sidebar
                  isLargeLessonView={false}
                  lessonName={lessonData.lessondetails.lessonname}
                  isAssessment={isAssessment}
                  isSurvey={isSurvey}
                  topics={lessonData.topics}
                  topicToLoad={topicToLoad}
                  lessonid={lessonid}
                  onClickTopics={onClickTopics}
                  handleRetakeAction={handleRetakeAction}
                  isRetakeClicked={isRetakeClicked}
                  lessondetails={lessonData.lessondetails}
                  selectedLanguage={selectedLanguage}
                  languageChangeHandler={(language) => {
                    handleLanguageChange(language);
                  }}
                  ackFlag={ackFlag}
                />
              </Col>
            )}
              <Col
                lg={showSidebar && sideBarToggle ? "9" : "12"}
                md={showSidebar && sideBarToggle ? "9" : "12"}
                sm={showSidebar && sideBarToggle ? "9" : "12"}
                xs="12"
              >
                {/* Assessment card strip: Question X of Y | progress | Score + Pass/Fail */}
                {isAssessment && (
                  <AssessmentProgressBar
                    topics={lessonData.topics}
                    topicToLoad={topicToLoad}
                    lessondetails={lessonData.lessondetails}
                    completionRecord={latestCompletionRecord}
                    allCompletionRecords={allCompletionRecords}
                    maxAttemptLimitReached={maxAttemptLimitReached}
                    maxAttemptsAssessment={maxAttemptsAssessment}
                    maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                  />
                )}
                <MediaFrame
                  retakeFlag={retakeFlag}
                  isAssessment={isAssessment}
                  maxAttemptLimitReached={maxAttemptLimitReached}
                  maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                  isSurvey={isSurvey}
                  topicToLoad={topicToLoad}
                  selectedLanguage={selectedLanguage}
                  topics={lessonData.topics}
                  lessonid={lessonid}
                  clickNextBtnFunc={clickNextBtnFunc}
                  clickPrevBtnFunc={clickPrevBtnFunc}
                  sideBarToggle={sideBarToggle}
                  handleRetakeAction={handleRetakeAction}
                  isRetakeClicked={isRetakeClicked}
                  isLargeLessonView={isLargeLessonView}
                  setIsLargeLessonView={setIsLargeLessonView}
                  setSideBarToggle={setSideBarToggle}
                />
              </Col>
            </Row>
          ) : (
            <Row
              style={{ width: "100%" , height: "100%" }}
              className="mt-3"
            >
              <Col lg="12" md="12" sm="12" xs="12">
                {isAssessment && (
                  <AssessmentProgressBar
                    topics={lessonData.topics}
                    topicToLoad={topicToLoad}
                    lessondetails={lessonData.lessondetails}
                    completionRecord={latestCompletionRecord}
                    allCompletionRecords={allCompletionRecords}
                    maxAttemptLimitReached={maxAttemptLimitReached}
                    maxAttemptsAssessment={maxAttemptsAssessment}
                    maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                  />
                )}
                <MediaFrame
                  retakeFlag={retakeFlag}
                  isAssessment={isAssessment}
                  maxAttemptLimitReached={maxAttemptLimitReached}
                  maxAttemptsAssessmentMessage={maxAttemptsAssessmentMessage}
                  isSurvey={isSurvey}
                  topicToLoad={topicToLoad}
                  selectedLanguage={selectedLanguage}
                  topics={lessonData.topics}
                  lessonid={lessonid}
                  clickNextBtnFunc={clickNextBtnFunc}
                  clickPrevBtnFunc={clickPrevBtnFunc}
                  sideBarToggle={sideBarToggle}
                  handleRetakeAction={handleRetakeAction}
                  // isRetakeClicked={isRetakeClicked}
                  isLargeLessonView={isLargeLessonView}
                  setIsLargeLessonView={setIsLargeLessonView}
                  setSideBarToggle={setSideBarToggle}
                />
              </Col>
            </Row>
          )}
        </Container>
        <Dialog
          header={`No Topics to Display`}
          visible={notTopicsDialogVisible}
          position={"top"}
          style={{ width: "50Vw" }}
          onHide={() => setNoTopicsDialogVisible(false)}
          draggable={false}
          resizable={false}
        >
          <Card className="mt-1">
            <Card.Body className="p-2">
              No active topics are available for this Lesson, please try gain
              later.
            </Card.Body>
          </Card>
        </Dialog>
        <Dialog
          header={`Are you sure?`}
          visible={retakeDialogVisible}
          position={"center"}
          style={{ width: "50Vw" }}
          onHide={() => setRetakeDialogVisible(false)}
          draggable={false}
          resizable={false}
        >
          <p>
            {" "}
            Please note, choosing to retake the assessment will erase your prior
            training record for this lesson. Are you sure you wish to proceed?{" "}
          </p>
          <div className="float-right">
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => {
                setRetakeDialogVisible(false);
              }}
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              id="retakeAssessmentSure"
              onClick={(e) => {
                handleRetakeAction(e);
              }}
              type="button"
              className="btn btn-light"
            >
              {/*   */}
              Retake Assessment
            </button>
          </div>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div className="lessonviewPage app" style={{ overflowX: "hidden" }}>
        <Header
          isLargeLessonView={isLargeLessonView}
          searchDashboardData={searchDashboardData}
          hideNavbar={hideNavbar}
          onTrialDUserLoaded={setIsTrialDUser}
        />
        {isPageLoading && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
            <i className="pi pi-spinner pi-spin" style={{ fontSize: "2rem", color: "#0f7439" }}></i>
          </div>
        )}
      </div>
    );
  }
};
export default LessonviewLarge;
